import * as React from 'react';
import { graphql } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { getTemplateById } from 'graphql/operations';
import { Paper, Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { getIdFromUrlParams } from 'selectors/assessment/selector';
import { NETWORK_ONLY } from 'graphql/fetchPolicies';
import './NewRecord.scss';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Button from 'components/common/Buttons/Button';
import LoadingPage from 'components/common/Loader/Spinner/Spinner';
import { isFetchingTemplate, getTemplate } from './selector';

export const NewRecordSuccessBase = props => {
  const { t: translate, template, isLoading, urlGuid, history } = props;
  const appName = template?.name;

  const handleSubmitAnother = React.useCallback(() => {
    history.push(`/new/${urlGuid}`);
  }, [urlGuid, history]);

  return isLoading ? (
    <LoadingPage size="lg" expanded />
  ) : (
    <div className="new-record-container">
      <div className="assessment-page assessment-row">
        <section className="col-sm-8 new-record-section">
          <Paper elevation={2} className="success-paper-style new-record-success-container">
            <div className="success-section">
              <CheckCircle className="success-icon" />
              <Typography variant="h1" className="success-title">
                {translate('newRecord.successTitle')}
              </Typography>
              <Typography variant="h1">
                {translate('newRecord.successSubCopy')}
                <br />
                {`${appName}?`}
              </Typography>
              <Button variant="contained" className="create-another" onClick={handleSubmitAnother}>
                {translate('newRecord.initiateAnother')}
              </Button>
            </div>
          </Paper>
        </section>
      </div>
    </div>
  );
};

export const NewRecordSuccessHOC = compose(
  withTranslation(),
  withRouter,
  graphql(getTemplateById, {
    options: props => ({
      variables: {
        id: getIdFromUrlParams(props)
      },
      fetchPolicy: NETWORK_ONLY
    })
  }),
  mapProps(props => {
    const template = getTemplate(props);
    return {
      t: props.t,
      history: props.history,
      isLoading: isFetchingTemplate(props),
      template,
      urlGuid: getIdFromUrlParams(props)
    };
  })
);

export const NewRecordSuccess = NewRecordSuccessHOC(NewRecordSuccessBase);
